import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';

const feedbackPage = PageBlueprint.make({
  name: 'feedback',
  params: {
    path: '/feedback',
    title: 'Team Feedback',
    icon: <ThumbsUpDownIcon />,
    loader: () => import('./FeedbackPage').then(m => <m.FeedbackPage />),
  },
});

const adminFeedbackPage = PageBlueprint.make({
  name: 'admin-feedback',
  params: {
    path: '/admin/feedback',
    title: 'All Feedback',
    icon: <ThumbsUpDownIcon />,
    loader: () => import('./FeedbackPage').then(m => <m.FeedbackPage readAll />),
  },
});

export const feedbackModule = createFrontendModule({
  pluginId: 'app',
  extensions: [feedbackPage, adminFeedbackPage],
});
